import type { FleetView, VehicleView } from "../../app/hooks/useBuses.js";

/** Coaches only, the caller's own coach first, the rest in fleet order. Its own module so the pager file exports components only. */
export function orderCoaches(fleet: FleetView, myId: string | null): VehicleView[] {
  const coaches = fleet.vehicles.filter((v) => v.kind === "bus");
  const mine = (v: VehicleView) => (myId ? v.bunks.some((b) => b.personId === myId) : false);
  return [...coaches.filter(mine), ...coaches.filter((v) => !mine(v))];
}
